import { post } from "config/infra";
import PasswordRepository from "domain/repository/Password";
import { ChangePasswordRequest, ChangePasswordResponse } from "domain/entity/Password";


export default class PasswordApi implements PasswordRepository {
    postChangePassword(body: ChangePasswordRequest): Promise<ChangePasswordResponse> {
        return post<ChangePasswordResponse, ChangePasswordRequest>('/password/change', body)
    }
}